import { TextFormsPanel } from "../TextFormsPanel";
import { PanelSection } from "./PanelSection";
import { ScreenFrame } from "./ScreenFrame";
import { SettingsSection } from "./SettingsSection";

export function FormsScreen(): JSX.Element {
  return (
    <ScreenFrame screen="forms">
      <SettingsSection screen="forms" />
      <PanelSection title="Text forms" panelIds={["text_forms"]}>
        <TextFormsPanel />
      </PanelSection>
    </ScreenFrame>
  );
}
